<template>

  <v-row align="center" justify="center">
    <v-snackbar
        v-model="showMessage"
        vertical
        bottom
        center
        :color="messageColor"
    >
      <p class="mb-0">{{ message }}</p>
    </v-snackbar>
    <v-col cols="10" sm="6" md="4">
      <v-card class="elevation-24 rounded-xl background-login">
        <v-window v-model="step">
          <v-window-item :value="1">
            <v-row>
              <v-col cols="12">
                <v-card-text class="mt-12">
                  <v-img
                      src="@/assets/loespejo-logo.png"
                      class="mx-auto"
                      max-width="250"
                      contain
                  ></v-img>

                  <v-form class="mt-8">
                    <v-text-field
                        name="Email"
                        v-model="email"
                        :rules="emailRules"
                        type="text"
                        background-color="white"
                        required
                        prepend-inner-icon="mdi-account"
                        outlined
                        dense
                        class="inputForm"
                        filled
                        color="primary"
                        placeholder="Email"
                    />

                    <v-text-field
                        id="password"
                        name="password"
                        v-model="password"
                        :rules="passwordRules"
                        prepend-inner-icon="mdi-lock"
                        type="password"
                        required
                        color="primary"
                        outlined
                        :append-icon="passType ? 'mdi-eye' : 'mdi-eye-off'"
                        @click:append="() => (passType = !passType)"
                        :type="passType ? 'password' : 'text'"
                        background-color="white"
                        class="inputForm"
                        dense
                        placeholder="Contraseña"
                    />
                  </v-form>
                <div class="text-center white--text">
                  <v-btn
                      :loading="loading"
                      :disabled="loading"
                      block
                      variant="text"
                      elevation="0"
                      @click="loginUser">Ingresar
                  </v-btn>
                </div>
                  <h3 class="text-center mt-4 white--text font-weight-light">¿No tienes cuenta? <router-link to="/register" style="color: #FFF;">Regístrate</router-link></h3>
<!--                   <h3 class="text-center mt-4 white--text font-weight-light">¿Olvidaste tu contraseña?</h3> -->
                <p @click="$router.push('/forgot-password')" style="text-decoration: underline;color: #FFFF;cursor: pointer;margin-bottom: 12px; display: flex;  justify-content: center; margin-top: 8px;">Has olvidado tu contraseña?</p>
                </v-card-text>
              </v-col>

            </v-row>
          </v-window-item>
        </v-window>
      </v-card>
      <v-alert v-if="verified"  style="margin: 20px auto;" type="success">Correo electrónico verificado</v-alert>
    </v-col>
  </v-row>

</template>

<script>
import {login, register} from '@/helpers/api/user'

export default {
  name: "Login",
  data: () => ({
    verified: false,    
    loading: false,
    step: 1,
    email: "",
    password: "",
    name: "",
    passType: true,
    message: "",
    messageColor: "",
    showMessage: false,
    nameRules: [
      (v) => !!v || "El nombre es requerido",
    ],
    passwordRules: [
      v => !!v || 'Contraseña es requerida'
    ],
    emailRules: [
      v => !!v || 'Email es obligatorio',
      v => /.+@.+\..+/.test(v) || 'Email debe ser válido',
    ],
  }),
  props: {
    source: String
  },
  methods: {
    goToRegister() {
      this.name = ''
      this.email = ''
      this.password = ''
      this.step++
    },
    goToLogin() {
      this.name = ''
      this.email = ''
      this.password = ''
      this.step--
    },
    async registerUser() {
      const data = {
        name: this.name,
        email: this.email,
        password: this.password
      }
      register(data).then(res => {
        console.log(res)
        this.goToLogin()
      }).catch(err => {
        console.log(err)
      })
    },
    loginUser() {
      this.loading = true;
      const self = this
      login(this.email, this.password, this.$store.state.area_id)
          .then(function (resp) {
            self.loading = false
            localStorage.setItem('userToken', resp.data.accessToken)
             if (self.$route.query && self.$route.query.redirect_to) {
               self.$router.push({ path: self.$route.query.redirect_to, query: {id: self.$route.query.id, reservation_id: self.$route.query.reservation_id}  });
               } else {
                 self.$router.push({ path: '/reserva'});
               }
          })
          .catch(function (error) {
            self.loading = false
            self.message = 'Lo sentimos, ha ocurrido un error inesperado. Por favor inténtalo nuevamente.'
            if (error.response &&( error.response.status === 401 || error.response.status === 400)) {
              self.message = 'Email o contraseña incorrectos. Por favor verifica los datos ingresados.'
            }
            self.messageColor = 'warning'
            self.showMessage = true
            console.log(error.response)
          })
    },

  },
  mounted () {
    if (this.$route.query.verified) {
      this.verified = true
    }
}
}
</script>

<style scoped>
.background-login {
  background: linear-gradient(140deg,#3587c2 0%, #003153 100%) !important;
}

.inputForm {
  border-radius: 10px !important;
}
</style>
